import { IAnswer, IConditionAnswer } from "./features/qa/types";

export class ApiResult<T>
{
    public result?: T;
    public errormessage: string = '';    
}
export interface ValuationResult
{
    condition: string;
    mileage: number;
    wholesalePrice: number;
}
export interface ICondition
{
   number: string;
   section: string;
   name: string;
   question: string;
   good: string;
   average: string;
   poor: string;
   value: number;
}

interface IRadioValue {
  label: string, 
  value: any
}

export enum YesNoNotSure {
  Yes = 2,
  NotSure = -1,
  No = 1,
  NotSet = 0
}

export const baseName = '/instant-offer';

export enum Routes {
  Specs = `/specs`, 
  Condition = `/condition`, 
  Personal = `/personal`, 
  Offer = `/offer`
}

export enum AnalyticElement {
  Button = 'button',
  Field = 'field'
}
export enum AnalyticType {
  Focus = 'focus',
  Click = 'click'
}
export interface IAnalyticEvent {
  type: AnalyticType,
  element: AnalyticElement,
  name: string
}

export interface ICustomer {
  firstName: string,
  lastName: string,
  email: string,
  mobile: string,
  terms: boolean,
  marketing: boolean, 
  dealerBranch: string
}
export interface IVehicleResult {
  redbookcode: string
  rbid: string
  makecode: string
  familycode: string
  vehicletype: string
  year: string
  month: string
  sequenceno: string
  description: string
  newvehicleflag: string
  importflag: string
  limitededition: string
  series: string
  badge: string
  badge2nd: string
  bodystyle: string
  drive: string
  geartype: string
  gearlocation: string
  gearnum: string
  doornum: string
  enginesize: string
  enginedesc: string
  cylinders: string
  fueltype: string
  induction: string
  cam: string
  enginetype: string
  fuelcapacity: string
  fueldelivery: string
  methoddelivery: string
  gvm: string
  wheelbase: string
  height: string
  length: string
  width: string
  kerbweight: string
  taremass: string
  power: string
  powerrpmto: string
  torque: string
  torquerpmfrom: string
  torquerpmto: string
  seatcapacity: string
  avgkm: string
  gdkm: string
  newprice: string
  make: string
  family: string
  isBestMatch: boolean;
  imageUrl: string
  matchDebug?: VehicleInfo;
}
export interface VehicleInfo {
  registrationNumber: string;
  state: string;
  vin: string;
  model: string;
  grade: string;
  manufacturedYear: string;
  vehicleAge: string;
  deliveryDate: string;
  manufacturer: string;
  source: string;
  compliancePlate: string;
  vehicleDescription: string;
  sellingDealerCode: string;
  sellingDealerName: string;
  materialNumber: string;
}
export interface IVehicleValued {
	year: string;
	make: string;
	family: string;
	badge: string;
	badge2nd: string;
	vehicleSummary: string;
	vehicleSpec: string;
  vehicleImage: string;
  redbookCode: string;
  chosenVehicle: IVehicleResult;
}
export interface ILead {
  instantOfferAppVersion: string,
  dealerID: number
  stockDealerID: number
  locationName: string
  firstName: string
  lastName: string
  mobile: string
  email: string
  offerDate: string,
  rego: string
  state: string
  kms: number
  vin: string
  vehicleValued?: IVehicleValued
  conditions?: Array<IConditionAnswer>
  redbookCode: string
  valuation: number
  answers?: Array[IAnswer]

  nextPurchase: string
  offerAccepted: boolean
  dealerBranch : string
  valuationResult?: IValuationResult 
  colour: string
  //MOVE
  //chosenVehicle?: IVehicleResult
}
// export interface IValuationRouteParams 
// {
//     rego?: string;
//     kms?: string;
//     auststate?: string;
// }
// export interface IValuationResultRouteParams 
// {
//     redbookcode?: string;
//     kms?: string;
// }


export interface IValuationRequest {
	conditions?: Array<any>,
	redbookCode: string
	kms: number
}
export interface IValuationResult {
	conditionAnswers?: Array<any>
	redbookCode: string,
	kms: number,
	kmUsed: number,
	valuation: number,
	pricingMatchInfo: string
}